
import moment from 'moment';

export const sumLabHours = (date, labHours) => {
  const newDate = moment(date); // Ensure date is a moment object
  const days = Math.floor(labHours / 8);
  const hours = labHours % 8;
  newDate.add(days, 'days').add(hours, 'hours');
  return newDate.format('YYYY-MM-DD HH:mm:ss');
}